import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue'

// Import global SCSS
import './assets/scss/main.scss'

// Import views
import Home from './views/Home.vue'
import About from './views/About.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})

const app = createApp(App)
app.use(router)
app.use(VueReCaptcha, {
	siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
	loaderOptions: {
		autoHideBadge: false, // optional (badge styling)
	},
});

app.mount('#app')